// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.documentViewer {
    visibility: hidden;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
.documentViewer--visible {
    visibility: visible;
    z-index: 1202;
}
.documentViewer__closeIcon {
    cursor: pointer;
    right: 0;
    top: 0;
    position: absolute;
    margin-right: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./../mirage/src/components/documentViewer/documentViewer.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,eAAe;IACf,MAAM;IACN,SAAS;IACT,OAAO;IACP,QAAQ;AACZ;AACA;IACI,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,eAAe;IACf,QAAQ;IACR,MAAM;IACN,kBAAkB;IAClB,oBAAoB;AACxB","sourcesContent":[".documentViewer {\n    visibility: hidden;\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n}\n.documentViewer--visible {\n    visibility: visible;\n    z-index: 1202;\n}\n.documentViewer__closeIcon {\n    cursor: pointer;\n    right: 0;\n    top: 0;\n    position: absolute;\n    margin-right: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
